import React from 'react';
// import './index.css';
import 'antd/dist/antd.min.css';
// import './App.css';
import {HashRouter as Router, Route,Switch,Redirect} from 'react-router-dom';
import Login from "./components/login/login";
import Main from './layout/main';


class App extends React.Component {
    render(){
        return (
            <>
            <Router>
                <Switch>
                    <Route exact path="/"   render={() => <Redirect to={'/login'} push />}  />
                    <Route path="/login" component = {Login}  exact />
                    <Route exact path="" component = {Main} />
                </Switch>
            </Router>
            
            </>
        )
    }

}

export default App;
